import { format } from "date-fns";
import type { useSwpStats } from "creso-core/hooks";
import { formatShort, titleCase } from "creso-core/utils";
import { StatTile } from "../../primitives";
import { StatsBar } from "./stats-bar";

export type SwpStatsData = NonNullable<
  ReturnType<typeof useSwpStats>["data"]
>;

export function SwpStats({
  stats,
  className,
}: {
  stats?: SwpStatsData;
  className?: string;
}) {
  if (!stats) return null;

  return (
    <StatsBar className={className}>
      <StatTile
        label="Monthly Withdrawals"
        value={
          stats.total_active_swp_amount
            ? formatShort(stats.total_active_swp_amount)
            : "-"
        }
      />
      <StatTile label="Active SWPs" value={stats.active_swp_count} />
      <StatTile
        label="Total Withdrawn"
        value={
          stats.total_withdrawn_amount
            ? formatShort(stats.total_withdrawn_amount)
            : "-"
        }
      />
      {stats.frequencies && (
        <StatTile
          label="Frequency"
          value={stats.frequencies.map((f) => titleCase(f)).join(", ")}
        />
      )}
      {stats.next_installment_date && (
        <StatTile
          label="Next Installment"
          value={format(stats.next_installment_date, "PP")}
        />
      )}
    </StatsBar>
  );
}
